import {
    SquareAcademicCapBoldDuotoneIcon,
    PrinterBoldDuotoneIcon,
    Routing2BoldDuotoneIcon,
    QuestionSquareBoldDuotoneIcon,
    FireBoldDuotoneIcon,
    BookBookmarkBoldDuotoneIcon,
} from '@solar-icons/react';
import FeatureTile from './FeatureTile';
import styles from './FeatureGrid.module.css';

const TILE_STYLE = {
    lessons: {icon: SquareAcademicCapBoldDuotoneIcon, tone: 'accent', hero: true},
    resources: {icon: PrinterBoldDuotoneIcon, tone: 'secondary'},
    walkthrough: {icon: Routing2BoldDuotoneIcon, tone: 'raised'},
    questions: {icon: QuestionSquareBoldDuotoneIcon, tone: 'raised'},
    scorcher: {icon: FireBoldDuotoneIcon, tone: 'inverse'},
    dictionary: {icon: BookBookmarkBoldDuotoneIcon, tone: 'secondary'},
};

const DISPLAY_ORDER = ['lessons', 'resources', 'walkthrough', 'scorcher', 'questions', 'dictionary'];

export default function FeatureGrid({content}) {
    const items = [...content.items].sort(
        (a, b) => DISPLAY_ORDER.indexOf(a.icon) - DISPLAY_ORDER.indexOf(b.icon)
    );

    return (
        <section className={styles.section} aria-labelledby="home-features">
            <div className={styles.inner}>
                <h2 id="home-features" className={styles.heading}>{content.heading}</h2>
                <ul className={styles.grid}>
                    {items.map((item) => {
                        const tileStyle = TILE_STYLE[item.icon];
                        if (!tileStyle) {
                            return null;
                        }
                        return (
                            <FeatureTile
                                key={item.label}
                                label={item.label}
                                icon={tileStyle.icon}
                                tone={tileStyle.tone}
                                hero={tileStyle.hero}/>
                        );
                    })}
                </ul>
            </div>
        </section>
    );
}
